const getUser = () => {
  const user = localStorage.getItem("user");
  if (user) {
    return JSON.parse(user);
  }
  const userCookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith("user="))
    ?.split("=")[1];
  if (userCookie) {
    return JSON.parse(decodeURIComponent(userCookie));
  }
  return null;
};
const setUser = (user) => {
  const cookieUser = document.cookie
    .split("; ")
    .find((row) => row.startsWith("user="))
    ?.split("=")[1];

  if (cookieUser) {
    // Decode the cookie data before storing in localStorage
    localStorage.setItem("user", decodeURIComponent(cookieUser));
  } else {
    localStorage.setItem("user", JSON.stringify(user));
  }
};

const removeUser = () => {
  // Remove cookie from current host
  document.cookie = "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

  document.cookie =
    "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=educationplanner.io;";

  document.cookie =
    "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.educationplanner.io;";

  // Clear storages
  localStorage.removeItem("user");
  localStorage.clear();
  sessionStorage.clear();
};

const getLocalAccessToken = () => {
  const cookieUser = document.cookie
    .split("; ")
    .find((row) => row.startsWith("user="))
    ?.split("=")[1];

  if (cookieUser) {
    try {
      const parsedCookieUser = JSON.parse(decodeURIComponent(cookieUser));
      return parsedCookieUser?.token;
    } catch (e) {
      return undefined;
    }
  } else {
    const user = JSON.parse(localStorage.getItem("user"));
    return user?.token;
  }
};
const getCompnayId = () => {
  const cookieUser = document.cookie
    .split("; ")
    .find((row) => row.startsWith("user="))
    ?.split("=")[1];

  if (cookieUser) {
    try {
      const parsedCookieUser = JSON.parse(decodeURIComponent(cookieUser));
      return parsedCookieUser?.companyId;
    } catch (e) {
      return undefined;
    }
  } else {
    const user = JSON.parse(localStorage.getItem("user"));
    return user?.companyId;
  }
};
const getUserRole = () => {
  const cookieUser = document.cookie
    .split("; ")
    .find((row) => row.startsWith("user="))
    ?.split("=")[1];

  if (cookieUser) {
    try {
      const parsedCookieUser = JSON.parse(decodeURIComponent(cookieUser));
      return parsedCookieUser?.role;
    } catch (e) {
      return undefined;
    }
  } else {
    const user = JSON.parse(localStorage.getItem("user"));
    return user?.role;
  }
};

const setCookieUserInLocalStorage = () => {
  const cookieUser = document.cookie
    .split("; ")
    .find((row) => row.startsWith("user="))
    ?.split("=")[1];
  if (cookieUser) {
    // Decode the cookie data before storing
    localStorage.setItem("user", decodeURIComponent(cookieUser));
  }
};

const initializeTokenFromCookie = () => {
  // Check if user exists in localStorage
  const localUser = localStorage.getItem("user");

  const cookieUser = document.cookie
    .split("; ")
    .find((row) => row.startsWith("user="))
    ?.split("=")[1];

  // If we have a cookie but no localStorage user, sync the data
  if (cookieUser && !localUser) {
    try {
      // Decode the cookie data and store the decoded JSON string
      const decodedCookieData = decodeURIComponent(cookieUser);
      localStorage.setItem("user", decodedCookieData);
      console.log("User data synced from cookie to localStorage successfully");
    } catch (error) {
      console.error("Error setting user in localStorage:", error);
      // If localStorage fails, we might need to reload as fallback
      const hasReloaded = sessionStorage.getItem("tokenReloaded");
      if (!hasReloaded) {
        sessionStorage.setItem("tokenReloaded", "true");
        window.location.reload();
        return false;
      }
    }
  }

  // If both exist, ensure they're in sync
  if (cookieUser && localUser) {
    setCookieUserInLocalStorage();
  } else if (!cookieUser && !localUser) {
    console.log("No authentication data found");
  }

  // Clear any leftover reload flag
  sessionStorage.removeItem("tokenReloaded");

  return true;
};

const TokenService = {
  getUser,
  setUser,
  removeUser,
  getLocalAccessToken,
  getCompnayId,
  getUserRole,
  setCookieUserInLocalStorage,
  initializeTokenFromCookie,
};
export default TokenService;
